class SmartLogin extends React.Component {

    constructor(props) {
        super(props);
        this.displayName = 'Smart Login';
        this.state = {
            sessionPerson: props.sessionPerson,
            sessionPersonHasUser: props.sessionPersonHasUser,
            isLoggedIn: props.isLoggedIn,
            userNameValue: props.sessionPerson.email || '',
            passwordValue: '',
            passwordRepeatValue: '',
            isLoading: false,
            isInvalid: false,
            errors: []
        };
        this.captcha = false;
        this.loginFormRef = React.createRef();
        this.gRecaptchaRef = React.createRef();
        this.userNameInputRef = React.createRef();
        this.passwordInputRef = React.createRef();
        this.passwordRepeatInputRef = React.createRef();

    }

    componentDidMount() {
        if(typeof grecaptcha !== 'undefined') {
            this.renderCaptcha();
        }else {
            $(document).on('recaptchaLoad', this.renderCaptcha.bind(this));
        }
    }

    renderCaptcha() {
        if(this.captcha === false && this.props.channelSettings && this.props.channelSettings['show_captcha'] === "1" && !this.state.isLoggedIn) {
            this.captcha = grecaptcha.render(this.gRecaptchaRef.current, {
                'sitekey': this.props.channelSettings['captcha_site_key'],
            });
        }
    }

    render() {
        let loadingMask = null;
        if(this.state.isLoading){
            loadingMask = <div className="loading-mask"/>;
        }
        let title = this.getTitle();
        let userInfo = this.getUserInfo();
        let userNameField = this.getUserNameField();
        let passwordField = this.getPasswordField();
        let passwordRepeatField = this.getPasswordRepeatField();
        let buttons = this.getButtons();
        let links = this.getLinks();
        let errors = this.getErrors();

        if(this.state.isLoggedIn){
            return (
                <div className="form-inner">
                    <div className="form-title">
                        {title}
                    </div>
                    <div className="form-body">
                        {userInfo}
                    </div>
                    {buttons}
                </div>
            );
        }

        return (
            <form ref={this.loginFormRef.current} className={"login-form" + (this.state.isInvalid ? ' is-invalid' : '')} action={this.props.submitUrl} autoComplete={this.props.autoComplete}>
                <div className="form-inner">
                    {loadingMask}
                    <div className="form-title">
                        {title}
                    </div>
                    {this.props.settings.force_saml_login !== '1' ? (
                        <div className="form-body">
                            {userInfo}
                            <div className="form-fields">
                                {userNameField}
                                {passwordField}
                                {passwordRepeatField}
                                {errors}
                            </div>
                        </div>
                    ) : undefined}
                    <div ref={this.gRecaptchaRef.current} className="g-recaptcha"/>
                    {buttons}
                    {links}
                </div>
            </form>
        );
    }

    onSubmit(event) {
        event.preventDefault();

        this.setState({
            isLoading: true
        });

        let data = {
            'data[User][password]': this.state.passwordValue,
            'data[User][password_repeat]': this.state.passwordRepeatValue,
        };
        if(this.state.sessionPerson === false){
            data['data[User][username]'] = this.state.userNameValue;
        }
        if(this.props.channelSettings && this.props.channelSettings['show_captcha'] === "1"){
            data["g-recaptcha-response"] = grecaptcha.getResponse(this.captcha);
        }

        $.ajax({
            url: this.props.submitUrl,
            cache: false,
            type: 'POST',
            data: data,
            dataType : 'json',
            abortOnRetry: false,
            error: (jqXHR, textStatus, errorThrown) => {
                this.setState({
                    isLoading: false,
                    isInvalid: true,
                    errors: ['There was an error while processing your request. Please try again.']
                });
            },
            success : (responseData, textStatus, jqXHR) => {
                if(responseData.twoFactorRedirect){
                    window.location.href = responseData.twoFactorRedirect;
                    return;
                }
                if(!responseData.success){
                    this.setState({
                        isLoading: false,
                        isInvalid: true,
                        errors: responseData.errors
                    });
                }else{
                    window.location.href = this.props.redirectUrl;
                }
            },
            complete: () => {
                if(this.props.channelSettings && this.props.channelSettings['show_captcha'] === "1") {
                    grecaptcha.reset(this.captcha);
                }
            }
        });
    }

    onSamlClick(event) {
        event.preventDefault();
        window.location.href = '/p/Users/Saml/login?idp=' + this.props.settings.saml_idp;
    }

    onLogoutClick(event) {
        event.preventDefault();
        window.location.href = this.props.logoutRedirectUrl;
    }

    handleUserNameChange(event) {
        this.setState({
            userNameValue: event.target.value
        });
    }

    handlePasswordChange(event) {
        this.setState({
            passwordValue: event.target.value
        });
    }

    handlePasswordRepeatChange(event) {
        this.setState({
            passwordRepeatValue: event.target.value
        });
    }

    getErrors() {
        let errors = [];
        $.each(this.state.errors, (key, error) => {
            if($.isArray(error)){
                $.each(error, (k, err) => {
                    errors.push(<p key={'error' + key + k}>{err}</p>);
                });
            }else {
                errors.push(<p key={'error' + key}>{error}</p>);
            }
        });

        return (
            <div className="form-errors">
                {errors}
            </div>
        );
    }

    getButtons() {
        if(this.state.isLoggedIn){
            return (
                <div className="form-buttons one-button">
                    <button onClick={this.onLogoutClick.bind(this)}>LOG OUT</button>
                    <div className="clearfix"/>
                </div>
            );
        }
        if (this.props.settings.force_saml_login === '1') {
            return (
                <div className="form-buttons one-button">
                    <button onClick={this.onSamlClick.bind(this)}>{this.props.settings.saml_button_text}</button>
                    <div className="clearfix"/>
                </div>
            );
        }
        return (
            <div className={"form-buttons " + (this.props.settings.show_saml_login === '1' ? 'two-button' : 'one-button')}>
                <button onClick={this.onSubmit.bind(this)}>LOG IN</button>
                {this.props.settings.show_saml_login === '1' &&
                    <button onClick={this.onSamlClick.bind(this)}>{this.props.settings.saml_button_text}</button>
                }
                <div className="clearfix"/>
            </div>
        );
    }

    getLinks() {
        if (this.props.settings.force_saml_login === '1') {
            return undefined;
        }
        return (
            <div className="form-links">
                {this.props.settings.show_create_account === '1' && !this.state.sessionPerson &&
                    <div className="sign-up">
                        <span>Don't have an account?</span>
                        {this.props.settings['popup_registration'] !== '1' &&
                            <a href={this.props.signUpUrl}>Sign Up Now!</a>
                        }
                        {this.props.settings['popup_registration'] === '1' &&
                            <a href="javascript:void(0);" className="open-register-popup">Sign Up Now!</a>
                        }
                    </div>
                }
                {(!this.state.sessionPerson || this.state.sessionPersonHasUser) &&
                    <div className="recover-password">
                        <a href={this.props.forgotPasswordUrl}>Forgot your password?</a>
                    </div>
                }
                <div className="clearfix"/>
            </div>
        );
    }

    getUserInfo() {
        if (this.state.sessionPerson === false) return null;

        let imagePath = SS.com.FileManager.frontend.util.Resizer.getResizedPath(this.state.sessionPerson.DefaultPhoto.path, 96, 96, null, true);

        return (
            <div className="login-form-user-info">
                {imagePath.match('no-image') ? undefined :
                    <img src={imagePath} alt={this.state.sessionPerson.fullname}/>}
                <h4>{this.state.sessionPerson.fullname}</h4>
                <h5>{this.state.sessionPerson.email}</h5>
                {!this.state.isLoggedIn &&
                    <a href={SS.route('People', 'People', 'removePersonFromSession', null, null)}>Click here if this is not you</a>
                }
                <div className="clearfix"/>
            </div>
        );
    }

    getUserNameField() {
        if(this.state.sessionPerson !== false){
            return null;
        }

        return (
            <div className={'login-form-field user-name-field' + (this.state.sessionPerson ? ' field-disabled' : '')}>
                <input
                    ref={this.userNameInputRef.current}
                    id="username"
                    // name="data[User][username]"
                    name="username"
                    placeholder="Email"
                    type="text"
                    value={this.state.userNameValue}
                    onChange={this.handleUserNameChange.bind(this)}
                />
            </div>
        );
    }

    getPasswordField() {
        return (
            <div className="login-form-field password-field">
                <input
                    ref={this.passwordInputRef.current}
                    id="password"
                    // name="data[User][password]"
                    name="password"
                    placeholder="Password"
                    type="password"
                    value={this.state.passwordValue}
                    onChange={this.handlePasswordChange.bind(this)}
                />
            </div>
        );
    }

    getPasswordRepeatField() {
        let renderRepeatPassword = true;
        if(this.state.sessionPerson !== false && this.state.sessionPersonHasUser){
            renderRepeatPassword = false;
        }
        if(!this.state.sessionPerson){
            renderRepeatPassword = false;
        }
        if(!renderRepeatPassword) return null;

        return (
            <div className="login-form-field password-repeat-field">
                <input
                    ref={this.passwordRepeatInputRef.current}
                    id="password-repeat"
                    // name="data[User][password-repeat]"
                    name="password-repeat"
                    placeholder="Repeat Password"
                    type="password"
                    value={this.state.passwordRepeatValue}
                    onChange={this.handlePasswordRepeatChange.bind(this)}
                />
            </div>
        );
    }

    getTitle() {
        let title = null;
        if(!this.state.isLoggedIn) title = 'Log in to your account';
        if(this.state.sessionPerson !== false && this.state.sessionPersonHasUser) title = 'Log in to your account';
        if(this.state.sessionPerson !== false && !this.state.sessionPersonHasUser) title = 'Set a password for your account';
        if(this.state.isLoggedIn) title = 'Welcome,';

        return <h1>{title}</h1>;
    }
}

SmartLogin.defaultProps = {
    captcha: false,
    sessionPerson: false,
    sessionPersonHasUser: false,
    isLoggedIn: false,
    autoComplete: 'on'
};

SmartLogin.propTypes = {
    forgotPasswordUrl: PropTypes.string.isRequired,
    submitUrl:  PropTypes.string.isRequired,
    signUpUrl:  PropTypes.string,
    redirectUrl: PropTypes.string,
    logoutRedirectUrl: PropTypes.string,
    sessionPerson: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object
    ]),
    sessionPersonHasUser: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    settings: PropTypes.object.isRequired,
    channelSettings: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
    ]).isRequired,
    autoComplete: PropTypes.oneOf(['on', 'off']),
};
